<template>
  <section class="content close-date-picker">
    <div class="box-body">
      <div class="main_select_wrp_relative">
        <!-- <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
                <svg  xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><g transform="translate(0 -1028.4)"><path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)"/><path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)"/><path d="m1 1028.4 9 11h4l9-11z" fill="#fff"/><path d="m1 1028.4 9 11h2v-11z" fill="#fff"/></g></svg>Apply Filter
                </button> -->
        <div
          class="modal fade model_modify_wrp"
          id="filtertoogle"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document" style="width: 50%">
            <div class="modal-content">
              <div class="modal-header">
                <h2>Filters</h2>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="main_select_wrp">
                  <div class="flex selectwca_wrp">
                    <div class="multiselected">
                      <label>Select City</label>
                      <multiselect
                        track-by="value"
                        label="name"
                        placeholder="Select City"
                        :options="cityList"
                        name="city"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        @select="onCheckedCity"
                        @remove="onRemoveCity"
                      >
                      </multiselect>
                    </div>
                    <div class="multiselected">
                      <label>Start location</label>
                      <multiselect
                        track-by="value"
                        label="name"
                        placeholder="Start location"
                        :options="startLocationList"
                        multiple
                        name="startLocation"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        @select="getStartLocation"
                        @remove="onRemoveSL"
                      >
                        <span style="display:block" slot="noResult"
                          >Oops! No elements found</span
                        >
                      </multiselect>
                    </div>
                    <div class="multiselected">
                      <label>End location</label>
                      <multiselect
                        track-by="_id"
                        label="name"
                        placeholder="End location"
                        :options="endLocationList"
                        multiple
                        name="endLocation"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        @select="getEndLocation"
                        @remove="onRemoveEL"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="addButtonClass">
        <div class="filter_wrpp">
          <button
            type="button"
            class="btn gradientbt"
            data-toggle="modal"
            data-target="#filtertoogle"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:cc="http://creativecommons.org/ns#"
              xmlns:dc="http://purl.org/dc/elements/1.1/"
              xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            >
              <g transform="translate(0 -1028.4)">
                <path
                  d="m10 11v10l4 3v-13h-4z"
                  fill="#fff"
                  transform="translate(0 1028.4)"
                />
                <path
                  d="m10 11v10l2 1.5v-11.5h-2z"
                  fill="#fff"
                  transform="translate(0 1028.4)"
                />
                <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
              </g></svg >
              Apply Filter
                    <span :class="{'counter_filter' : count }">{{ count }}</span>
          </button>
        </div>
        <div class="datedrop_boxs_wrp">
          <span v-if="date.startDate"></span>
          <span v-else
            ><button
              type="button"
              class="btn gradientbt"
              v-on:click="show = !show"
            >
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 122.88 119.97"
                style="enable-background:new 0 0 122.88 119.97"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M69.76,4.06c0-2.23,2.2-4.06,4.95-4.06s4.95,1.81,4.95,4.06V21.8c0,2.23-2.2,4.06-4.95,4.06s-4.95-1.81-4.95-4.06V4.06 L69.76,4.06L69.76,4.06z M14.37,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37 c-0.72,0-1.31-0.59-1.31-1.31v-8.38C13.06,78.63,13.65,78.05,14.37,78.05L14.37,78.05z M57.79,54.17h11.34 c0.35,0,0.66,0.14,0.9,0.36c-4.45,2.78-8.31,6.4-11.37,10.65h-0.87c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C56.48,54.76,57.07,54.17,57.79,54.17L57.79,54.17z M36.08,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,54.76,35.36,54.17,36.08,54.17L36.08,54.17z M14.37,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C13.06,54.76,13.65,54.17,14.37,54.17L14.37,54.17z M36.08,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,78.63,35.36,78.05,36.08,78.05L36.08,78.05z M103.49,59.54c11.71,4.85,19.39,16.28,19.39,29.02c0,8.67-3.52,16.53-9.2,22.21c-5.68,5.68-13.53,9.2-22.21,9.2 c-8.67,0-16.52-3.52-22.21-9.2c-5.68-5.69-9.2-13.54-9.2-22.21c0-12.64,7.86-24.43,19.55-29.23 C86.86,56.37,96.29,56.55,103.49,59.54L103.49,59.54L103.49,59.54z M86.64,87.72c0.39-0.43,0.87-0.8,1.39-1.08V72.98 c0-1.39,1.13-2.52,2.52-2.52c1.39,0,2.53,1.13,2.53,2.52v13.66c0.92,0.5,1.68,1.25,2.17,2.17h9.76c1.4,0,2.52,1.13,2.52,2.52 s-1.13,2.52-2.52,2.52h-9.76c-0.9,1.68-2.66,2.82-4.7,2.82c-1.6,0-3.03-0.71-4.01-1.82C84.73,92.78,84.82,89.69,86.64,87.72 L86.64,87.72L86.64,87.72z M110.12,70.41c-13.01-13.01-34.95-9.33-42.56,7.05c-1.56,3.37-2.44,7.13-2.44,11.09 c0,7.28,2.95,13.87,7.72,18.64c4.77,4.77,11.36,7.72,18.64,7.72c7.28,0,13.87-2.96,18.64-7.72c4.77-4.77,7.72-11.36,7.72-18.64 c0-4.13-0.95-8.04-2.64-11.52C113.91,74.4,112.19,72.48,110.12,70.41L110.12,70.41L110.12,70.41z M25.33,4.06 c0-2.23,2.2-4.06,4.95-4.06c2.74,0,4.95,1.81,4.95,4.06V21.8c0,2.23-2.21,4.06-4.95,4.06c-2.74,0-4.95-1.81-4.95-4.06V4.06 L25.33,4.06L25.33,4.06z M5.45,38.79h94.21V18.37c0-0.7-0.28-1.31-0.73-1.76c-0.45-0.45-1.09-0.73-1.76-0.73h-9.03 c-1.51,0-2.74-1.23-2.74-2.74c0-1.51,1.23-2.74,2.74-2.74h9.03c2.21,0,4.2,0.89,5.65,2.34c1.45,1.45,2.34,3.44,2.34,5.65v32.43 c-1.8-0.62-3.65-1.12-5.56-1.49v-5.07h0.06H5.45v52.91c0,0.7,0.28,1.31,0.73,1.76c0.45,0.45,1.09,0.73,1.76,0.73h44.77 c0.51,1.9,1.15,3.76,1.92,5.54H7.99c-2.2,0-4.2-0.89-5.65-2.34C0.89,101.4,0,99.42,0,97.21V18.39c0-2.2,0.89-4.19,2.34-5.65 c1.45-1.45,3.44-2.34,5.65-2.34h9.64c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H7.99c-0.7,0-1.31,0.28-1.76,0.73 c-0.45,0.45-0.73,1.09-0.73,1.76v20.43H5.45V38.79L5.45,38.79z M43.13,15.87c-1.51,0-2.74-1.23-2.74-2.74 c0-1.51,1.23-2.74,2.74-2.74h18.39c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H43.13L43.13,15.87L43.13,15.87z"
                  />
                </g>
              </svg>
              Select Start and End Dates
            </button></span
          >

          <span v-if="date.startDate">
            <div class="datemodify" v-on:click="show = true">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 122.88 119.97"
                style="enable-background:new 0 0 122.88 119.97"
                xml:space="preserve"
              >
                <g>
                  <path
                    d="M69.76,4.06c0-2.23,2.2-4.06,4.95-4.06s4.95,1.81,4.95,4.06V21.8c0,2.23-2.2,4.06-4.95,4.06s-4.95-1.81-4.95-4.06V4.06 L69.76,4.06L69.76,4.06z M14.37,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37 c-0.72,0-1.31-0.59-1.31-1.31v-8.38C13.06,78.63,13.65,78.05,14.37,78.05L14.37,78.05z M57.79,54.17h11.34 c0.35,0,0.66,0.14,0.9,0.36c-4.45,2.78-8.31,6.4-11.37,10.65h-0.87c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C56.48,54.76,57.07,54.17,57.79,54.17L57.79,54.17z M36.08,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,54.76,35.36,54.17,36.08,54.17L36.08,54.17z M14.37,54.17h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38c0,0.72-0.59,1.31-1.31,1.31H14.37c-0.72,0-1.31-0.59-1.31-1.31v-8.38 C13.06,54.76,13.65,54.17,14.37,54.17L14.37,54.17z M36.08,78.05h11.34c0.72,0,1.31,0.59,1.31,1.31v8.38 c0,0.72-0.59,1.31-1.31,1.31H36.08c-0.72,0-1.31-0.59-1.31-1.31v-8.38C34.77,78.63,35.36,78.05,36.08,78.05L36.08,78.05z M103.49,59.54c11.71,4.85,19.39,16.28,19.39,29.02c0,8.67-3.52,16.53-9.2,22.21c-5.68,5.68-13.53,9.2-22.21,9.2 c-8.67,0-16.52-3.52-22.21-9.2c-5.68-5.69-9.2-13.54-9.2-22.21c0-12.64,7.86-24.43,19.55-29.23 C86.86,56.37,96.29,56.55,103.49,59.54L103.49,59.54L103.49,59.54z M86.64,87.72c0.39-0.43,0.87-0.8,1.39-1.08V72.98 c0-1.39,1.13-2.52,2.52-2.52c1.39,0,2.53,1.13,2.53,2.52v13.66c0.92,0.5,1.68,1.25,2.17,2.17h9.76c1.4,0,2.52,1.13,2.52,2.52 s-1.13,2.52-2.52,2.52h-9.76c-0.9,1.68-2.66,2.82-4.7,2.82c-1.6,0-3.03-0.71-4.01-1.82C84.73,92.78,84.82,89.69,86.64,87.72 L86.64,87.72L86.64,87.72z M110.12,70.41c-13.01-13.01-34.95-9.33-42.56,7.05c-1.56,3.37-2.44,7.13-2.44,11.09 c0,7.28,2.95,13.87,7.72,18.64c4.77,4.77,11.36,7.72,18.64,7.72c7.28,0,13.87-2.96,18.64-7.72c4.77-4.77,7.72-11.36,7.72-18.64 c0-4.13-0.95-8.04-2.64-11.52C113.91,74.4,112.19,72.48,110.12,70.41L110.12,70.41L110.12,70.41z M25.33,4.06 c0-2.23,2.2-4.06,4.95-4.06c2.74,0,4.95,1.81,4.95,4.06V21.8c0,2.23-2.21,4.06-4.95,4.06c-2.74,0-4.95-1.81-4.95-4.06V4.06 L25.33,4.06L25.33,4.06z M5.45,38.79h94.21V18.37c0-0.7-0.28-1.31-0.73-1.76c-0.45-0.45-1.09-0.73-1.76-0.73h-9.03 c-1.51,0-2.74-1.23-2.74-2.74c0-1.51,1.23-2.74,2.74-2.74h9.03c2.21,0,4.2,0.89,5.65,2.34c1.45,1.45,2.34,3.44,2.34,5.65v32.43 c-1.8-0.62-3.65-1.12-5.56-1.49v-5.07h0.06H5.45v52.91c0,0.7,0.28,1.31,0.73,1.76c0.45,0.45,1.09,0.73,1.76,0.73h44.77 c0.51,1.9,1.15,3.76,1.92,5.54H7.99c-2.2,0-4.2-0.89-5.65-2.34C0.89,101.4,0,99.42,0,97.21V18.39c0-2.2,0.89-4.19,2.34-5.65 c1.45-1.45,3.44-2.34,5.65-2.34h9.64c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H7.99c-0.7,0-1.31,0.28-1.76,0.73 c-0.45,0.45-0.73,1.09-0.73,1.76v20.43H5.45V38.79L5.45,38.79z M43.13,15.87c-1.51,0-2.74-1.23-2.74-2.74 c0-1.51,1.23-2.74,2.74-2.74h18.39c1.51,0,2.74,1.23,2.74,2.74c0,1.51-1.23,2.74-2.74,2.74H43.13L43.13,15.87L43.13,15.87z"
                  />
                </g>
              </svg>
              <input v-model="date.startDate" /> to
              <input v-model="date.endDate" />
            </div>
          </span>
          <span v-else> </span>

          <div v-if="show" class="datedrop_boxs">
            <date-picker
              @change="startDate()"
              id="startDate"
              v-model="date.startDate"
              lang="en"
              name="startDate"
              required
              input-class="form-control"
              width="100%"
              valueType="format"
              :format="'DD-MM-YYYY'"
              placeholder="Start date"
            ></date-picker>
            <date-picker
              @change="endDate()"
              :not-before="startDateIso"
              id="endDate"
              v-model="date.endDate"
              lang="en"
              name="endDate"
              required
              input-class="form-control"
              width="100%"
              valueType="format"
              :format="'DD-MM-YYYY'"
              placeholder="End date"
            ></date-picker>
          </div>
        </div>
        <router-link
          :to="{ name: 'createSecondaryTrip', params: { _id: '0' } }"
        >
          <button class=" btn gradientbt">Add Transfer Point Trip</button>
        </router-link>
      </div>
      <v-server-table
        ref="secondaryTripTable"
        url
        :limit="5"
        :columns="columns"
        :options="options"
        @loaded="onLoaded"
      >
        <template slot="beforeBody">
          <tr v-if="loading" class="VueTables__no-results">
            <td class="text-center" colspan="9">
              <pulse-loader></pulse-loader>
            </td>
          </tr>
        </template>
        <template slot="action" slot-scope="props">
          <div class="c-pointer">
            <!-- <router-link :to="{ name: 'viewPrimaryTrip' }">View Details</router-link>-->
            <a v-on:click.stop="action(props.row)">View Details</a>
          </div>
        </template>
      </v-server-table>
    </div>
  </section>
</template>

<script>
import { USER_ROLES } from "../../../config";
import { Event } from "vue-tables-2";
import moment from "moment";
import { mapState } from "vuex";
import { secondaryTripService } from "../../../services";
import dateFormatter from "../../utilities/dateFormate";
export default {
  name: "secondaryTrip",
  data() {
    return {
      disabledAfter: null,
      show: false,
      date: {
        startDate: "",
        endDate: "",
      },
      page: null,
      limit: null,
      loading: null,
      secondaryTripTable: null,
      parameters: {},
      endDateIso: "",
      startDateIso: "",
      statusValue: "",
      noResult: true,
      cityList: [],
      startList: [],
      endList: [],
      startLocationList: [],
      endLocationList: [],
      columns: [
        "city",
        "transferPoint",
        "destinationLocation",
        "vehicle",
        "driver",
        "waste",
        "status",
        "scheduleTime",
        "action",
      ],
      options: {
        highlightMatches: true,
        sortable: [],
        headings: {
          city: "City",
          transferPoint: "Start Location",
          destinationLocation: "End Location",
          vehicle: "Vehicle",
          driver: "Driver",
          waste: "Total Weight [KG]",
          status: "Status",
          scheduleTime: "Start Date",
          action: "Action",
        },
        templates: {
          scheduleTime(row, query) {
            return dateFormatter(query.scheduleTime);
            // return moment(query.scheduleTime).format("DD-MM-YYYY");
          },
        },
        perPage: 10,
        sortable: [
          "transferPoint",
          "destinationLocation",
          "vehicle",
          "driver",
          "waste",
          "status",
          "scheduleTime",
        ],
        requestFunction: (request) => {
          this.parameters.page = request.page;
          this.parameters.limit = request.limit;
          this.page = request.page;
          this.limit = request.limit;
          if (this.startDateIso && this.endDateIso) {
            this.parameters.startDate = this.startDateIso;
            this.parameters.endDate = this.endDateIso;
          } else {
            delete this.parameters.startDate;
            delete this.parameters.endDate;
          }
          if (request.orderBy) {
            if (request.orderBy == "city") {
              this.parameters.sortBy = "cityId.cityName";
            } else if (request.orderBy == "transferPoint") {
              this.parameters.sortBy = "transportPointId.transportName";
            } else if (request.orderBy == "destinationLocation") {
              this.parameters.sortBy = "endLoc.plantName";
            } else if (request.orderBy == "driver") {
              this.parameters.sortBy = "driverId.firstName";
            } else if (request.orderBy == "vehicle") {
              this.parameters.sortBy = "vehicleId.vNumber";
            } else if (request.orderBy == "waste") {
              this.parameters.sortBy = "totalWeight";
            } else {
              this.parameters.sortBy = request.orderBy;
            }
            if (request.ascending == 1) {
              this.parameters.sortOrder = "asc";
            } else {
              this.parameters.sortOrder = "dsc";
            }
          }
          if (request.query) {
            // if(request.query.length < 3) return;
            this.parameters.searchString = request.query.trim();
          } else {
            delete this.parameters.searchString;
          }
          this.loading = true;
          return secondaryTripService
            .getList(this.parameters)
            .catch((error) => {
              console.error("trip.requestFunction-error:", error);
              this.$snotify.error("Get Trip", "Error!");
            });
        },
        responseAdapter: (response) => {
          this.loading = false;
          let dataResp = [];
          response.data.secondaryTripData.forEach((element) => {
            let finalData = element;
            finalData["city"] = element.cityId ? element.cityId.cityName : "--";
            finalData["transferPoint"] = element.transportPointId
              ? element.transportPointId.transportName
              : "--";
            finalData["destinationLocation"] = element.endLoc
              ? element.endLoc.plantName
              : "--";
            finalData["vehicle"] = element.vehicleId
              ? element.vehicleId.vNumber
              : "--";
            finalData["driver"] = element.driverId
              ? element.driverId.firstName
              : "--";
            finalData["waste"] = element.totalWeight;
            finalData["createdAt"] = element.createdAt;
            finalData["status"] =
              element.tripStatus.charAt(0).toUpperCase() +
              element.tripStatus.slice(1);
            finalData["startDate"] = element.startTime
              ? element.startTime
              : "--";
            dataResp.push(finalData);
          });
          return {
            data: dataResp,
            count: response.data.count || dataResp.length,
          };
        },
        uniqueKey: "_id",
      },
    };
  },
  computed: {
    addButtonClass() {
      if (this.secondaryTripTable) {
        return this.secondaryTripTable.count > this.secondaryTripTable.limit ||
          this.secondaryTripTable.limit > 10
          ? "shift-add-left"
          : "add-item";
      } else {
        return "add-item";
      }
    },
  },

  methods: {
    startDate() {
      const eventData = this.date.startDate.split("-");
      const startDates = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
      this.startDateIso = new Date(startDates).toISOString();
      if (this.date.startDate != "" && this.date.endDate != "") {
        this.getListByDate();
      } else {
        this.$refs.secondaryTripTable.refresh();
      }
    },
    endDate() {
      if (this.date.startDate != "" && this.date.endDate != "") {
        const eventData = this.date.endDate.split("-");
        const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
        this.endDateIso = new Date(endDate).toISOString();
        this.getListByDate();
      } else {
        this.$refs.secondaryTripTable.refresh();
      }
    },

    getListByDate() {
      this.parameters.page = this.page;
      this.parameters.limit = this.limit;
      this.parameters.startDate = this.startDateIso;
      this.parameters.endDate = this.endDateIso;
      this.loading = false;

      return secondaryTripService
        .getListDate(this.parameters)
        .then((response) => {
          this.$refs.secondaryTripTable.data = [];
          let dataResp = [];
          response.data.secondaryTripData.forEach((element) => {
            let finalData = element;
            finalData["city"] = element.cityId.cityName;
            finalData["transferPoint"] = element.transportPointId.transportName;
            finalData["destinationLocation"] = element.endLoc.plantName;
            finalData["vehicle"] = element.vehicleId.vNumber;
            finalData["driver"] = element.driverId.firstName;
            finalData["waste"] = element.totalWeight;
            finalData["status"] =
              element.tripStatus.charAt(0).toUpperCase() +
              element.tripStatus.slice(1);
            finalData["startDate"] = element.startTime
              ? element.startTime
              : "--";
            dataResp.push(finalData);
          });
          this.$refs.secondaryTripTable.data = dataResp;
          this.$refs.secondaryTripTable.count = dataResp.length;
        })
        .catch((error) => {
          console.error("Secondary Trip List .requestFunction-error:", error);
        });
    },

    onLoaded() {
      this.secondaryTripTable = this.$refs.secondaryTripTable;
    },

    action(data) {
      this.$router.push({
        name: "secondary",
        params: {
          _id: data._id,
        },
        props: data,
      });
    },

    getCityList() {
      const params = {};
      this.cityList = [];
      let cities = [];
      this.$cityRepository
        .collectionCitysList(params)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            if (element.status === true) {
              cities.push({
                name:
                  element.cityName.length > 20
                    ? element.cityName.slice(0, 20) + "..."
                    : element.cityName,
                value: element._id,
              });
            }
          });
          cities.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.cityList = cities;
        })
        .catch((error) => {
          this.loading = false;
          console.error("cities.requestFunction-error:", error);
          this.$snotify.error("Get cities list failed", "Error!");
        });
    },
    onCheckedCity(option) {
      let cityId = option.value;
      this.getTransportList(cityId);
      this.getEndLocations(cityId);
      this.parameters.cityIds = cityId;
      this.$refs.secondaryTripTable.refresh();
    },
    onRemoveCity(option) {
      let cityId = option.value;
      this.parameters.cityIds = "";
      this.$refs.secondaryTripTable.refresh();
      this.startLocationList = [];
      this.endLocationList = [];
    },
    getTransportList(id) {
      this.loading = true;
      this.startLocationList = [];
      let transportList = [];
      return secondaryTripService
        .getTransportList(id)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            transportList.push({
              name:
                element.transportName.length > 20
                  ? element.transportName.slice(0, 20) + "..."
                  : element.transportName,
              value: element._id,
            });
          });
          transportList.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.startLocationList = transportList;
          this.noResult = this.startLocationList.length > 0 ? false : true;
        })
        .catch((error) => {
          this.loading = false;
          console.error("getTransportList.requestFunction-error:", error);
          this.$snotify.error("Get transort List failed", "Error!");
        });
    },

    getEndLocations(id) {
      this.endLocationList = [];
      let endlocationSort = [];
      let locations = [];
      return secondaryTripService
        .getSegregationDumpyardList(id)
        .then((res) => {
          this.loading = false;
          res.data.response.forEach((element) => {
            locations.push({
              name:
                (element.plantName.length > 20
                  ? element.plantName.slice(0, 20) + "... "
                  : element.plantName) +
                "- " +
                element.name,
              _id: element._id,
            });
          });
          endlocationSort = locations;
          endlocationSort.sort((item1, item2) => {
            return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
          });
          this.endLocationList = endlocationSort;
        })
        .catch((error) => {
          this.loading = false;
          console.error("getEndLocations-error:", error);
        });
    },
    getStartLocation(option) {
      this.startList.push(option.value);
      let list = this.startList.join(",");
      this.parameters.startLoc = list;
      this.$refs.secondaryTripTable.refresh();
    },
    onRemoveSL(option) {
      this.startList = this.startList.filter((el) => el != option.value);
      let list = this.startList.join(",");
      this.parameters.startLoc = list;
      this.$refs.secondaryTripTable.refresh();
    },
    getEndLocation(option) {
      this.endList.push(option._id);
      let list = this.endList.join(",");
      this.parameters.endLoc = list;
      this.$refs.secondaryTripTable.refresh();
    },
    onRemoveEL(option) {
      this.endList = this.endList.filter((el) => el != option._id);
      let list = this.endList.join(",");
      this.parameters.endLoc = list;
      this.$refs.secondaryTripTable.refresh();
    },
  },
  mounted() {
    if (this.$store.state.auth.user.role.key === "superAdmin") {
      this.options.sortable.push("city");
    }
    document.addEventListener("click", (event) => {
      if (
        event.target.closest(".close-date-picker") &&
        !event.target.matches(".gradientbt") &&
        !event.target.closest(".datedrop_boxs") &&
        !event.target.closest(".datemodify")
      ) {
        this.show = false;
      }
    });
    this.getCityList();
  },
};
</script>

<style scoped>
.sorting {
  position: absolute;
  left: 319px;
  z-index: 1000;
  width: 225px;
  margin-left: 250px;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.inline {
  background-color: rgba(255, 132, 78);
  color: white;
}

.addnew {
  background-image: linear-gradient(
    to right,
    rgba(38, 153, 251),
    rgba(146, 205, 255)
  );
  color: white;
}
.main_select_wrp_relative .modal-dialog {
  width: 57% !important;
}
.main_select_wrp_relative {
  position: absolute;
  right: 30%;
  top: 25px;
}
.filter_wrpp button svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.filter_wrpp button {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.filter_wrpp button:hover {
  background: #0f6940;
  color: #fff;
}
.main_select_wrp_relative + .add-item {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// secondaryTripList.vue?1c291484